import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui, rydeColors } from "@ryde/theme";

export const EditAreaWaypointsDrawerBodyStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "edit-area-waypoints-drawer-body",
  },
)`
  display: grid;
  grid-template-columns: 420px 1fr;
  height: calc(100vh - 120px);
  min-height: 480px;

  .edit-area-waypoints-list {
    display: flex;
    flex-direction: column;
    border-inline-end: 1px solid ${greyMui._300};
    overflow: hidden;
  }

  .edit-area-waypoints-list-title {
    margin: 0;
    padding: 12px;
    border-bottom: 1px solid ${greyMui._200};
    font-size: 14px;
    font-weight: 600;
    color: ${greyMui._800};
  }

  .edit-area-waypoints-rows {
    overflow: auto;
    flex: 1;
    padding: 8px 0;
  }

  .edit-area-waypoints-empty-list {
    padding: 16px 12px;
    font-size: 13px;
    color: ${greyMui._600};
  }

  .edit-area-waypoints-map {
    height: 100%;
    min-height: 480px;
  }

  .edit-area-waypoints-row {
    display: grid;
    grid-template-columns: 20px 28px 1fr 32px;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border-bottom: 1px solid ${greyMui._100};
    background: ${rydeColors.white};
  }

  .edit-area-waypoints-row.is-dragging {
    opacity: 0.6;
  }

  .edit-area-waypoints-grip {
    cursor: grab;
    color: ${greyMui._500};
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .edit-area-waypoints-name-field {
    min-width: 0;
  }
`;
